export default __webpack_public_path__ + "static/media/Litto-2.62b0a7d1.png";